import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import parse from 'html-react-parser';
import { obscureEmail } from "../../../utils/utils";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";
import { handleApiError, safeJsonParse } from "../../../utils/api";

export interface TaskExampleAddProps {
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function TaskExampleAdd(props: TaskExampleAddProps) {
    const { t } = useTranslation();
    
    const navigate = useNavigate();

    const [tasksFound, setTasksFound] = useState<any[]>([]);
    const [taskSelected, setTaskSelected] = useState(null);
    const [processing, setProcessing] = useState(false);
    
    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = () => {
        let error = false;
        let error_messages: string[] = [];

        if (error) {
            alert(error_messages.join('\n'));
        } else {
            const requestOptionsPost = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify({
                    taskSelected: taskSelected
                })
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/examples/add', requestOptionsPost)
                .then(response => {
                    if (handleApiError(response, navigate)) {
                        return;
                    }
                    props.closeCallback();
                });
        }
    }

    const handleTasksSearch = (event: any) => {
        if (event.target.value.length < 3) {
            setTasksFound([]);
        } else {
            setProcessing(true);
            let reqUrl = import.meta.env.VITE_API_URL + '/v1/task/search/';
            let queryParams: string[] = [];
            queryParams.push('search=' + event.target.value);
            const requestOptionsPost = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            };
            reqUrl += '?' + queryParams.join('&');
            fetch(reqUrl, requestOptionsPost)
                .then(response => {
                    if (handleApiError(response, navigate)) {
                        return null;
                    }
                    return safeJsonParse(response);
                })
                .then(data => {
                    if (!data) return;
                    const newTasksFound = data.filter((tf: any) => tf.userId !== undefined && tf.userId != null).map((t: any) => {
                        let userlabel = obscureEmail(t.userId.email);
                        if (t.userId.profile.firstname || t.userId.profile.lastname) {
                            const label_array: string[] = [];
                            if (t.userId.profile.firstname) {
                                label_array.push(t.userId.profile.firstname);
                            }
                            if (t.userId.profile.lastname) {
                                label_array.push(t.userId.profile.lastname);
                            }
                            userlabel = label_array.join(' ');
                        }
                        return {
                            id: t._id,
                            label: t.name + ' (' + userlabel + ')'
                        }
                    });
                    setTasksFound(newTasksFound);
                    setProcessing(false);
                });
        }
    }

    const handleSelectTask = (event: any) => {
        const id = event.target.value;
        const checked = event.target.checked;
        if (checked) {
            setTaskSelected(id);
        }
    }

    return(
        <Overlay
            title={t("Add new Task Example")}
            onClose={handleClose}
            actions={[
                { label: t("Cancel"), variant: "secondary", onClick: handleClose },
                { label: t("Add selected tasks"), variant: "primary", onClick: handleSubmit, disabled: !taskSelected }
            ]}
        >
            <div className="admin-add-taskexamples-container">
                <div className="taskexample-form-container">
                    <div className="share-options-container">
                        <div className="search">
                            <Form.Control type="text" placeholder="Search tasks..." onChange={handleTasksSearch} />
                            {processing && <div className="processing"></div>}
                        </div>
                        {tasksFound.length > 0 &&
                            <div className="tasks">
                                <div className="found">
                                    <div className="label">
                                        {parse(t("Select the tasks you want to add as examples:"))}
                                    </div>
                                    <ul>
                                        {tasksFound.map((t: any) => {
                                            return <li key={`tasksFound-${t.id}`}>
                                                <input type="radio" name="taskSelected" value={t.id} onChange={handleSelectTask} />
                                                <span>
                                                    {t.label} <a className={'select-task' + (taskSelected !== undefined && taskSelected == t.id ? ' selected' : '')} onClick={handleSelectTask} id={`taskFound-${t.id}`}></a>
                                                </span>
                                            </li>;
                                        })}
                                    </ul>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Overlay>
    );
}